import { render, staticRenderFns } from "./CommonNotification.vue?vue&type=template&id=0e0585d8"
import script from "./CommonNotification.vue?vue&type=script&lang=js"
export * from "./CommonNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports